import {
    IDropdownOption,
    IFilterModel,
} from '@uipath/angular/components/ui-grid';

import cloneDeep from 'lodash-es/cloneDeep';

export type IFilterValueMap<T, K> = {
    [key in keyof T]?: IFilterModel<K>[]
};

interface IEnumMapOptions<T, K> {
    filterValueMap?: IFilterValueMap<T, K>;
    resourceKey: string;
    type?: EnumValueType;
    sort?: EnumSortDirection;
    filter?: (key: string) => boolean;
}

export enum EnumValueType {
    Key,
    Value,
}

export enum EnumSortDirection {
    descending = -1,
    ascending = 1,
}

export function enumMapper<K, T>(
    enumDefinition: T,
    { filterValueMap = {} as IFilterValueMap<T, K>, filter, sort, resourceKey, type }: IEnumMapOptions<T, K>,
): IDropdownOption[] {

    filter = filter || ((key) => isNaN(Number.parseInt(key, 10)));

    const keys = Object.keys(enumDefinition).filter(filter);

    if (sort != null) {
        keys.sort((a, b) => (a > b ? 1 : -1) * sort);
    }

    return keys
        .map(keyStr => {
            const key = keyStr as keyof T;
            let value = enumDefinition[key];

            if (type === EnumValueType.Key) {
                const mappedKey = value as unknown as keyof T;
                value = enumDefinition[mappedKey];
            }

            const valueStr = `${value}`;

            return {
                label: key.toString(),
                translationKey: `${resourceKey}_${key}`,
                value: filterValueMap[key] || valueStr,
            } as IDropdownOption; // FIXME: update the type of IDropdownOption.value
        });
}

export const globalStateFilter = (): IDropdownOption[] => cloneDeep([{
    value: true,
    label: 'Enabled',
    translationKey: 'GlobalFilter_Enabled',
}, {
    value: false,
    label: 'Disabled',
    translationKey: 'GlobalFilter_Disabled',
}]);

export const globalStateFilterOnOff = (): IDropdownOption[] => cloneDeep([{
    value: true,
    label: 'Enabled',
    translationKey: 'GlobalFilter_On',
}, {
    value: false,
    label: 'Disabled',
    translationKey: 'GlobalFilter_Off',
}]);
